import { render } from "./PersonalSavingsDocumentation.vue?vue&type=template&id=5c2231af&scoped=true"
import script from "./PersonalSavingsDocumentation.vue?vue&type=script&lang=js"
export * from "./PersonalSavingsDocumentation.vue?vue&type=script&lang=js"

import "./PersonalSavingsDocumentation.vue?vue&type=style&index=0&id=5c2231af&scoped=true&lang=css"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2231af"]])

export default __exports__